import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'
import {  Row, Col } from 'react-bootstrap';
import DeptLeft from '../People/Dept_Left'





function Main() {

    const ImageData = [

        { img: "https://files.iittp.ac.in/pdfs/btech/2024/Local_Taxi_Vendors_Details.png" },

       

      

    ]

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Information for B.Tech. 2026 Batch Students" />
            <section className="team-area fix p-relative pt-60 pb-80" >
                 

                {/* <div className="row">
                    <div className="col-lg-12 p-relative">
                        <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
               
                            <h3>Information for B.Tech 2024 Batch Students and Preparatory 2024 Students </h3> 
                            
                        </div>
                    </div>
                </div> */}
                <div className="container">
                <p className="caboutus">A warm welcome to all the new students who will be joining the B.Tech programme at IIT Tirupati in 2026. <b style={{ color: "blue" }}>An Orientation and Induction Program has been scheduled on <b> 27 July 2026 (Monday)</b>.</b> Students may plan to arrive on <Link className='c-link' to="https://www.google.com/maps/d/u/3/viewer?mid=1TdGW9XGZXc0Bzs2La43k1HoX2tFa50Y&ll=13.710984410416179%2C79.59363325&z=16" target="_blank;"><u>campus</u></Link> from <b>25 July 2026 (Saturday)</b> onwards. Please be advised that we may not be able to accommodate the students if they arrive earlier than scheduled. All the students must physically report for Biometric verification and Physical verification of certificates on <b>27 July 2026 (Monday) at 09.00 AM.</b> Please <Link className='c-link' to="https://files.iittp.ac.in/pdfs/btech/2026/Checklist_for_B.Tech_2026.pdf" target="_blank;"><u>click here</u></Link> to know the list of documents to be produced during the certificate verification.</p>
                <p className="caboutus">Due to the limited availability of rooms on the campus, accommodation will not be available for parents accompanying the students. Several options for stay are available in Tirupati or Srikalahasti.</p>
                <p className="caboutus"><b style={{ color: "blue" }}>A welcome email containing all necessary information will be sent to students allotted to IIT Tirupati, at their email ID registered with JoSAA, after the completion of all admission rounds.</b></p>
                {/* <p className="caboutus"><b style={{ color: "blue" }}>A welcome email has been sent to all students allotted to IIT Tirupati with all the necessary information to the registered email with JoSAA. Please check the 'SPAM' folder as well.</b></p> */}
                {/* <p className="caboutus"><b style={{ color: "blue" }}>A welcome email will be sent to all students allotted to IIT Tirupati with all the necessary information to the registered email with JoSAA.</b></p>  */}
                {/* Please check the 'SPAM' folder as well   */}
                    
                    <p className="caboutus">The students who missed the "<b>Open House - An Interactive Session for Prospective Students 2026 held on 06 June 2026 (Saturday)</b>" can watch it on the Institute Youtube Channel - <Link className='c-link' to="https://www.youtube.com/watch?v=hU-V9mrGWno&t=3s" target="_blank;"><u>Click here</u></Link></p>
                   <p><b>Please watch this space for more updates.</b></p>
                   <h4 className='c-headline  mb-3 mt-4'>Orientation Program, Fees Payment and Related Forms</h4>
                     <Row>
                        <Col md={12} className='c-left custom-padding-color'>
						<ul className='ms-3 c-lineheight2dot5 iarrow' >

                      <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Orientation & Induction Program Schedule : &nbsp;&nbsp;
                                        {/* <Link to="#" rel="noopener noreferrer"> 
                                        <b><u>Will be updated soon</u></b>
                                    </Link> */}
                                    <Link to="https://files.iittp.ac.in/pdfs/btech/2026/Yuvantar_B.Tech._Orientation_27_Jul_2026.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here</u></b>
                                    </Link>
                                 </li>

                                 <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Academic Calendar : &nbsp;&nbsp;
                                    <Link to="https://iittp.ac.in/academic-calender" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here</u></b>
                                    </Link>
                                 </li>

                                 <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Curriculum : &nbsp;&nbsp;
                                    <Link to="https://iittp.ac.in/b-tech-curriculum" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here</u></b>
                                    </Link>
                                 </li>
                                 <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Timetable : &nbsp;&nbsp;
                                    <Link to="https://iittp.ac.in/btechtimetable" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here</u></b>
                                    </Link>
                                 </li>
                                 <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> First Semester fee structure : &nbsp;&nbsp;
                                 {/*<Link to="#" rel="noopener noreferrer"> 
                                        <b><u>Will be updated soon</u></b>
                                    </Link> 
                                    </li>*/}
                                    <Link to="https://files.iittp.ac.in/pdfs/btech/2026/B.Tech_2026_First_Sem_Fee_Structure.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here</u></b>
                                    </Link>
                                 </li>
                                 <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Payment procedure document : &nbsp;&nbsp;
                                  {/*<Link to="#" rel="noopener noreferrer"> 
                                        <b><u>Will be updated soon</u></b>
                                    </Link> 
                                    </li>*/}
                                    <Link to="https://files.iittp.ac.in/pdfs/btech/2026/Fee_Payment_Procedure_July_2026.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here</u></b>
                                    </Link>
                                </li>
                                 <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Fee payment links : &nbsp;&nbsp;
                                    <Link to="https://iittp.plumerp.co.in/prod/iittirupati/" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here</u></b>
                                    </Link>
                                </li>
                                
                                    {/* <ul className='ms-3 c-lineheight2dot5 iarrow'>
                                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> B.Tech 2025 Students : &nbsp;&nbsp;
                                            <Link to="#" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Will be updated soon</u></b>
                                            </Link>
                                            <Link to="https://iittp.plumerp.co.in/prod/iittirupati/" target="_blank" rel="noopener noreferrer"> 
                                                <b><u>Payment link</u></b>
                                            </Link>
                                        </li>
                                        <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Preparatory 2025 Students : &nbsp;&nbsp;
                                            <Link to="#" target="_blank" rel="noopener noreferrer"> 
                                                <b><u>Payment link (Will be updated soon)</u></b>
                                            </Link>
                                        </li>
                                    </ul> */}
                                
                                 

                                 {/* <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Upload Fee Payment and Income certificate : &nbsp;&nbsp;
                                    <Link to="#" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Will be updated soon</u></b>
                                    </Link>
                                 </li> */}
                                 <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Statement of Expenditure : &nbsp;&nbsp;
                                   {/* <Link to="#" rel="noopener noreferrer"> 
                                        <b><u>Will be updated soon</u></b>
                                    </Link> 
                                    </li>*/}
                                    <Link to="https://files.iittp.ac.in/pdfs/soe/2026/B.Tech.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here</u></b>
                                    </Link>
                                 </li> 
                                 <li><ul><li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Medical Examination Report : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/btech/2023/4.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here</u></b>
                                    </Link>
                                    </li><li className="ms-4">
                                    (Part-A should be filled by the candidate. In case of Part-B, students may attach JoSAA Medical Certificate.)</li></ul>

                                 </li>
                                 <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Solemn Affirmation, Anti-ragging (Self Declaration by the Student and Parent/Guardian) : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/btech/2023/5.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here</u></b>
                                    </Link>
                                 </li>
                                 <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Student datasheet form : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/btech/2023/6.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here</u></b>
                                    </Link>
                                 </li>
                                  <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> PoSH Self Declaration/Undertaking : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/btech/2026/PoSH_Self_Declaration_Undertaking.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here</u></b>
                                    </Link>
                                 </li>
                                 <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Campus Map : &nbsp;&nbsp;
                                    <Link to="https://files.iittp.ac.in/pdfs/btech/2024/IITTirupati_Campus_Map.pdf" target="_blank" rel="noopener noreferrer"> 
                                        <b><u>Click here</u></b>
                                    </Link>
                                 </li>
                            </ul>
                        </Col>
                    </Row>
                    {/* <h4 className='c-headline  mb-3 mt-4'>Local Taxi Vendors Details </h4>
                    <Row>
                    <p>For easy reference to the New Students and their parents</p>
                    <div className="grid col6 row wow fadeInUp  animated" data-animation="fadeInUp" data-delay=".4s" >
                                    {ImageData.map((item, Index) => (
                                        <div className="grid-item financial col-6 mt-3" key={Index}>                        
                                                <figure className="gallery-image">
                                                    <img src={item.img} alt="img" className="img" />
                                                </figure>
                                        </div>
                                    ))}
                                </div>
                    </Row> */}<br/><br/>
                    <h5><b>Note</b> : In case of any queries, please write to <Link to="mailto:admissions@iittp.ac.in">admissions@iittp.ac.in</Link> or call 0877-250 3532 (9.00 AM to 5.30 PM on all working days)</h5>
                    
                </div>
               
                
                

            </section>
        </>
    )
}


export default Main;